import React from "react";
import AdnTable from "../common/adnTable/AdnTable";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnCard from "../common/adnCard/AdnCard";
import { Row, Col, Select, Space, Statistic, Card } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import AdnAutoComplete from "../common/adnAutoComplete/AdnAutoComplete";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import AdnAddButton from "../common/adnAddButton/AdnAddButton";
import AdnDropdown from "../common/adnDropdown/AdnDropdown";
import adnYesNoModal from "../common/adnYesNoModal/AdnYesNoModal";
import AdnMonthYearDropdown from "../common/adnMonthYearDropdown/AdnMonthYearDropdown";
import { AppRoutes } from "../../AppRoutes";

const ContractProposalListForm = ({
  contracts,
  handleOrderList,
  handleSearch,
  handleSelect,
  handleManagerSearch,
  handleManagerSelect,
  monthHandleChange,
  yearHandleChange,
  searchOptions,
  searchManagerOptions,
  searchManagerName,
  totalRecords,
  addContractProposal,
  careerLevel,
  contractTypes,
  handleContractTypeChange,
  handleCareerLevelChange,
  loading,
  setIsExcelUpdated,
  handleDelete,
  contractTypeId,
  month,
  year,
  contractTypesCounters,
}) => {
  const title = "Financial Proposals";
  const { Option } = Select;

  const navigate = useNavigate();

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: "10%",
      sorter: true,
      render: (text, record) => (
        <Link to={AppRoutes.contractProposalById.createPath(record.id)}>
          {record.name}
        </Link>
      ),
    },

    {
      title: "Career",
      dataIndex: "carrearLevelName",
      key: "carrearLevelName",
      width: "13%",
    },

    {
      title: " Contract",
      dataIndex: "contractTypeName",
      key: "contractTypeName",
      width: "15%",
      sorter: true,
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      width: "5%",
    },
    {
      title: "Manager Name",
      dataIndex: "managerName",
      key: "managerName",
      width: "9%",
    },
    {
      title: "Salary",
      dataIndex: "salary",
      key: "salary",
      width: "5%",
    },
    {
      title: "Actions",
      key: "action",
      render: (record) => (
        <Space size="middle">
          <EditOutlined
            style={{ color: "black" }}
            onClick={() => {
              navigate(AppRoutes.contractProposalById.createPath(record.id));
            }}
          />
          <DeleteOutlined
            style={{ color: "red" }}
            onClick={() => adnYesNoModal(() => handleDelete(record.id))}
          />
        </Space>
      ),
      width: "3%",
    },
  ];

  return (
    <>
      <AdnPageTitle title={title} />
      <Row justify="space-between" style={{ marginBottom: "1rem" }}>
        <Col span={6}>
          <Card style={{ height: "100%" }} loading={loading}>
            <Link
              to={AppRoutes.contractProposalListByContractType.createPath(1)}
            >
              <Statistic
                title={"CTI - Tempo Indeterminado"}
                value={
                  contractTypesCounters.find((x) => x.contractTypeId == 1)
                    ?.count
                }
                loading={loading}
              />
            </Link>
          </Card>
        </Col>
        <Col span={6}>
          <Card style={{ height: "100%" }} loading={loading}>
            <Link
              to={AppRoutes.contractProposalListByContractType.createPath(2)}
            >
              <Statistic
                title={"CPS - Prestação de Serviços"}
                value={
                  contractTypesCounters.find((x) => x.contractTypeId == 2)
                    ?.count
                }
                loading={loading}
              />
            </Link>
          </Card>
        </Col>
        <Col span={6}>
          <Card style={{ height: "100%" }} loading={loading}>
            <Link
              to={AppRoutes.contractProposalListByContractType.createPath(3)}
            >
              <Statistic
                title={"CTC - Termo Certo"}
                value={
                  contractTypesCounters.find((x) => x.contractTypeId == 3)
                    ?.count
                }
                loading={loading}
              />
            </Link>
          </Card>
        </Col>
        <Col span={6}>
          <Card style={{ height: "100%" }} loading={loading}>
            <Link
              to={AppRoutes.contractProposalListByContractType.createPath(4)}
            >
              <Statistic
                title={"Academia"}
                value={
                  contractTypesCounters.find((x) => x.contractTypeId == 4)
                    ?.count
                }
                loading={loading}
              />
            </Link>
          </Card>
        </Col>
      </Row>
      <AdnCard loading={loading}>
        <Row gutter={14}>
          <Col span={4}>
            <AdnAutoComplete
              placeholder={"Search name..."}
              valueId={"name"}
              handleSearch={handleSearch}
              handleSelect={handleSelect}
              resultList={searchOptions}
            />
          </Col>
          <Col span={4}>
            <AdnAutoComplete
              placeholder={"Search manager..."}
              valueId={"managerName"}
              defaultValue={searchManagerName}
              handleSearch={handleManagerSearch}
              handleSelect={handleManagerSelect}
              resultList={searchManagerOptions}
            />
          </Col>
          <Col span={5}>
            <AdnDropdown
              placeholder={"Career Level"}
              name="carrearLevelId"
              value={2}
              handleChange={handleCareerLevelChange}
              options={careerLevel}
              allowClear={true}
            />
          </Col>
          <Col span={4}>
            <AdnDropdown
              placeholder={"Contract Name"}
              defaultValue={contractTypeId != "" ? contractTypeId : null}
              value={contractTypeId != "" ? contractTypeId : null}
              handleChange={handleContractTypeChange}
              options={contractTypes}
              allowClear={true}
            />
          </Col>
          <Col span={5}>
            <AdnMonthYearDropdown
              allowMonthClear
              allowYearClear
              defaultMonthValue={month != "" ? month : null}
              defaultYearValue={year != "" ? year : null}
              handleMonthChange={monthHandleChange}
              handleYearChange={yearHandleChange}
            />
          </Col>
          <Col span={2}>
            <AdnAddButton
              handleClick={addContractProposal}
              name={"ContractProposal"}
            />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <AdnTable
              pagination={false}
              columns={columns}
              data={contracts}
              handleChange={handleOrderList}
              totalRecords={totalRecords}
            />
          </Col>
        </Row>
      </AdnCard>
    </>
  );
};

export default ContractProposalListForm;
